module.exports = __webpack_public_path__ + "img/logo 1.562f94d4.png";